import axios from '@/plugins/axios'

const getCategories = async ({ userId = null, parentId = null, visibility = null, search = null, page = 1 }) => {
  try {
    const params = {}
    if (userId) params.user_id = userId
    if (parentId) params.parent_id = parentId
    if (visibility) params.visibility = visibility
    if (search) params.search = search
    params.page = page
    const response = await axios.get('categories', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getCategory = async slug => {
  try {
    const response = await axios.get(`categories/${slug}`)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const postCategory = async (id = null, { name = '', slug = '', description = '', visibility = 'public', cover = null }) => {
  try {
    if (!description) description = ''
    if (!slug) slug = ''
    const form = new FormData()
    form.append('name', name)
    form.append('slug', slug)
    form.append('description', description)
    form.append('visibility', visibility)
    if (cover) form.append('cover', cover)
    if (id) form.append('_method', 'PUT')
    const url = id ? `categories/${id}` : 'categories'
    // console.log(url, name, slug, description, visibility, cover)
    const response = await axios.post(url, form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const destroy = async id => {
  try {
    const response = await axios.post(`categories/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  destroy,
  getCategories,
  getCategory,
  postCategory
}
